import React from "react"
import IndexRoutes from "./components/Routes/Routes";

const App = () => {
  return (
    <>
      <IndexRoutes />
    </>
  );
}

export default App;
